import { render, staticRenderFns } from "./KaiFormSelect.vue?vue&type=template&id=5a9803f8&scoped=true&"
import script from "./KaiFormSelect.vue?vue&type=script&lang=ts&"
export * from "./KaiFormSelect.vue?vue&type=script&lang=ts&"
import style0 from "./KaiFormSelect.vue?vue&type=style&index=0&id=5a9803f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9803f8",
  null
  
)

export default component.exports